// The built-in signup email's default wording and the button it adds, by
// whether the campaign asks people to confirm. Mirrors
// internal/services/builtinemail.
export const BUILTIN_SIGNUP = {
  confirm: { subject: "Please confirm your subscription", body: "Thanks for signing up! Please confirm your subscription with the button below." },
  welcome: { subject: "Thanks for subscribing!", body: "Welcome, and thanks for signing up. We're glad you're here." },
};
export const BUILTIN_CONFIRM_LABEL = "Confirm my subscription";

export const builtinSignupDefaults = (doubleOptIn) => BUILTIN_SIGNUP[doubleOptIn ? "confirm" : "welcome"];

// The campaign's emails for a slot (as business.EmailPool): the built-in
// one, or its own designs — the designs when it has no built-in email.
export function emailPool(campaign, followup = false) {
  const c = campaign || {};
  const variants = (c.mail_variants || []).filter(Boolean);
  let role = "signup";
  let builtin = c.signup_email_source !== "custom";
  if (followup && c.followup_email_source === "custom") {
    role = "followup";
    builtin = false;
  }
  const pick = (b) => variants.filter((v) => (v.role || "signup") === role && !!v.builtin === b);
  const pool = pick(builtin);
  return builtin && !pool.length ? pick(false) : pool;
}

// designsFor: the campaign's own designs for a slot.
export const designsFor = (campaign, role) =>
  ((campaign && campaign.mail_variants) || []).filter((v) => v && !v.builtin && (v.role || "signup") === role);
